import { ModalFooter } from '@chakra-ui/react'
import React from 'react'

interface EventModalFooterProps {
  children: React.ReactNode
  [key: string]: any
}

export const EventModalFooter: React.FC<EventModalFooterProps> = ({
  children,
  ...additionalProps
}) => {
  return (
    <ModalFooter p="0 24px 24px 24px" {...additionalProps}>
      {children}
    </ModalFooter>
  )
}
